import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';
import { Branch } from './branch';
import { Payment } from './payment';
import { PaymentInvoice } from './payment-invoice';
import { AuthenticationService } from '../../shared/services/authentication.service';
//import { forkJoin } from 'rxjs/observable/forkJoin';

@Injectable()
export class AccountingService {
  private _paymentUrl = this._configuration.apiUrl + "/v2/payment";
  private _paymentInvoiceUrl = this._configuration.apiUrl + "/v2/paymentinvoice";


  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  createPayment(payment: Payment): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.post(this._paymentUrl, payment, { headers: h, search: s }).map(response => response.json());
  }

  // Get all payments, if customer is supplied, will return only that customer's payments
  getPayments(customerId: number): Observable<Payment[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    if (customerId) {
      s.append('customer_id', customerId.toString());
    }

    return this._http.get(this._paymentUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['results'] == null || !Array.isArray(body['results']))
          return [];
        return body['results'];
      }
    );
  }

  // Creates an entry that ties invoices to a payment, with an amount
  createPaymentInvoice(paymentInvoices: PaymentInvoice[]): Observable<any[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return Observable.forkJoin(
      paymentInvoices.map( paymentInvoice => 
        this._http.post(this._paymentInvoiceUrl, paymentInvoice, { headers: h, search: s }).map(response => response.json()) )
      );

    //return this._http.post(this._paymentInvoiceUrl, paymentInvoice, { headers: h, search: s }).map(response => response.json());
  }

  // Returns all Payment Invoices associated to an invoice, which may be from multiple payments
  getPaymentInvoices(invoiceId?: number, paymentId?: number): Observable<PaymentInvoice[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    if (invoiceId) {
      s.append('invoice_id', invoiceId.toString());
    }

    if (paymentId) {
      s.append('payment_id', paymentId.toString());
    }

    return this._http.get(this._paymentInvoiceUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['results'] == null || !Array.isArray(body['results']))
          return [];
        return body['results'];
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/accounting.service.ts